import PageContainer                            from '@/components/pageContainer/PageContainer';
import PageTitle                                from '@/components/pageTitle/PageTitle';
import { useTranslation }                       from 'react-i18next';
import ContactsListBox                          from './components/ContactsListBox';
import { Box }                                  from '@chakra-ui/react';
import { Text }                                 from '@chakra-ui/react';
import { Button }                               from '@/components/ui/button';
import React                                    from 'react';
import { RiAddFill }                            from 'react-icons/ri';
import { RiCheckLine }                          from 'react-icons/ri';
import { RiTimeLine }                           from 'react-icons/ri';
import RelationRequestTargetResponseListBox     from './components/RelationRequestTargetResponseListBox';
import { useNavigate }                          from 'react-router-dom';
import { useLocation }                          from 'react-router-dom';
import useTranslations                          from '@/hooks/useTranslations';
import Modal                                    from '@/components/modal/Modal';
import { ModalData }                            from '@/components/modal/Modal';
import ContactForm                              from './forms/ContactForm';
import { toaster }                              from '@/components/ui/toaster';
import getTextAndTranslateFromError             from '@widesk-core/tools/getTextAndTranslateFromError.ts';

const ContactsPage = () => {

	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const { getNavigationTranslation } = useTranslations();
	const hash = location.hash.substring(1);
	const isOnPending = hash === getNavigationTranslation('contacts', 'hash');

	const [modalData, setModalData] = React.useState<ModalData | undefined>();
	const [modalIsOpen, setModalIsOpen] = React.useState(false);

	const [relationRequestsTotal, setRelationRequestsTotal] = React.useState(0);

	const fetchContactsRef = React.useRef<(() => Promise<void>)>();
	const fetchRelationRequestTargetResponseRef = React.useRef<(() => Promise<void>)>();

	return (
		<PageContainer>
			<Modal
				model={modalData?.model}
				isDangerous={modalData?.isDangerous}
				isOpen={modalIsOpen}
				setIsOpen={setModalIsOpen}
				titleComponent={modalData?.titleComponent}
				bodyComponent={modalData?.bodyComponent}
				onConfirm={modalData?.onConfirm}
				onClose={modalData?.onClose}
				onSuccess={modalData?.onSuccess}
			/>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="space-between"
			>
				<PageTitle>
					{t('pages.contacts.label')}
				</PageTitle>

				<Button
					onClick={() => {
						setModalData({
							setIsOpen: setModalIsOpen,
							titleComponent: <Text>{t('pages.contacts.forms.contactForm.title', { action: t('pages.contacts.actions.add') })}</Text>,
							bodyComponent: <ContactForm
								setIsOpen={setModalIsOpen}
								setModalData={setModalData}
								onSuccess={async () => {
									await fetchContactsRef.current?.();

									if (isOnPending) {
										const url = getNavigationTranslation('contacts', 'path');
										navigate(url);
									}

									setModalIsOpen(false);
									setModalData(undefined);
								}}
							/>,
							onClose: () => {
								setModalIsOpen(false);
								setModalData(undefined);
							},
							onError: (error) => {
								toaster.create({
									title: `${t('pages.contacts.forms.contactForm.errors.submit')} : ${getTextAndTranslateFromError(error)}`,
									type: 'error',
									duration: 5000,
								});
								setModalIsOpen(false);
								setModalData(undefined);
							},
						});
						setModalIsOpen(true);
					}}
				>
					<RiAddFill />
					{t('pages.contacts.actions.add')}
				</Button>
			</Box>
			<Box
				display="flex"
				alignItems="center"
				gap={2}
				overflow="auto"
			>
				<Button
					onClick={() => {
						const url = getNavigationTranslation('contacts', 'path');
						navigate(url);
						if (fetchContactsRef.current) {
							fetchContactsRef.current();
						}
					}}
					style={{
						opacity: isOnPending ? 0.5 : 1,
					}}
					variant={'outline'}
				>
					<RiCheckLine />
					{t('pages.contacts.filters.validatedContacts')}
				</Button>
				<Button
					onClick={() => {
						const url = getNavigationTranslation('contacts', 'path') + '#' + getNavigationTranslation('contacts', 'hash');
						navigate(url);
						if (fetchRelationRequestTargetResponseRef.current) {
							fetchRelationRequestTargetResponseRef.current();
						}
					}}
					style={{
						opacity: !isOnPending ? 0.5 : 1,
					}}
					variant={'outline'}
				>
					<RiTimeLine />
					{`${t('pages.contacts.filters.pendingContacts')} ${relationRequestsTotal ? `(${relationRequestsTotal})` : ''}`}
				</Button>
			</Box>
			<>
				<Box hidden={!isOnPending}>
					<RelationRequestTargetResponseListBox
						setModalData={setModalData}
						setModalIsOpen={setModalIsOpen}
						onListSuccess={(collection) => {
							setRelationRequestsTotal(collection.total)
						}}
						fetchRef={fetchRelationRequestTargetResponseRef}
					/>
				</Box>
				<Box hidden={isOnPending}>
					<ContactsListBox
						setModalData={setModalData}
						setModalIsOpen={setModalIsOpen}
						fetchRef={fetchContactsRef}
					/>
				</Box>
			</>
		</PageContainer>
	);
};

export default ContactsPage;